import React from "react"
import {
  FacebookShareButton,
  WhatsappShareButton,
  FacebookIcon,
  WhatsappIcon,
} from "react-share"
import { trackCustomEvent } from "gatsby-plugin-google-analytics"
import ShareIcon from "@src/images/share.svg"

interface ShareOptionsProps {
  url: string
  wsTitle?: string
}

const ShareOptions = ({ url, wsTitle }: ShareOptionsProps) => {
  const shareWithFacebook = () => {
    if (window["fbq"]) {
      fbq("trackCustom", "FacebookSharePost", { post_url: url })
    }
    trackCustomEvent({
      category: "FacebookSharePost",
      action: "Click",
      label: `Share post ${url}`,
    })
  }

  const shareWithWhatsApp = () => {
    if (window["fbq"]) {
      fbq("trackCustom", "WhatsAppSharePost", { post_url: url })
    }
    trackCustomEvent({
      category: "WhatsAppSharePost",
      action: "Click",
      label: `Share post ${url}`,
    })
  }

  return (
    <div className="flex flex-row items-center justify-between">
      <ShareIcon />
      <button className="outline-none flex" onClick={shareWithFacebook}>
        <FacebookShareButton className="w-8 ml-2" url={url}>
          <FacebookIcon className="h-8 w-8 rounded-md" />
        </FacebookShareButton>
      </button>
      <button className="outline-none flex" onClick={shareWithWhatsApp}>
        <WhatsappShareButton className="w-8 ml-2" url={url} title={wsTitle}>
          <WhatsappIcon className="h-8 w-8 rounded-md" />
        </WhatsappShareButton>
      </button>
    </div>
  )
}

export default ShareOptions
